import {
    VARIANT_DISCOUNTS_DISPLAY_BAR,
    VARIANT_DISCOUNTS_CRUD_FORM_DONE,
    VARIANT_DISCOUNTS_CRUD_FORM_CANCEL,
    VARIANT_DISCOUNTS_CRUD_FORM_BATCH_EDIT
} from "./actions/VariantEditorActions";
import {
    getDiscountsByVariantId,
    updateDiscountsByVariantId
} from "../api/actions/VariantActions";
import {
    putDiscountsToVariants,
    deleteDiscountsFromVariants,
    deleteAllDiscountsFromVariants
} from "../api/actions/DiscountActions";
import { $serializeForm } from "../main";

export const cancelVariantDiscountEditEvent = () => {
    return async (dispatch, state) => {
        dispatch(VARIANT_DISCOUNTS_CRUD_FORM_CANCEL());
    }
};

export const enableVariantDiscountsBatchEditEvent = () => {
    return async (dispatch, state) => {
        dispatch(VARIANT_DISCOUNTS_CRUD_FORM_BATCH_EDIT({ discounts: [] }));
    }
};
export const disableVariantDiscountsBatchEditEvent = () => {
    return async (dispatch, state) => {
        dispatch(VARIANT_DISCOUNTS_CRUD_FORM_CANCEL());
    }
};

export const enableVariantDiscountEditEvent = (variant) => {
    return async (dispatch, state) => {

        if (typeof state.variantDiscounts != 'object') {
            state.variantDiscounts = {};
        }

        getDiscountsByVariantId(variant.id)
            .then((result) => {
                //console.log();
                let discounts = result.content || [];
                if (Array.isArray(discounts) && discounts.length > 0) {
                    discounts = discounts.map(discount => ({ id: discount.id, name: discount.name }));
                }
                console.log();
                dispatch(VARIANT_DISCOUNTS_CRUD_FORM_DONE({ ...variant, discounts: discounts }));
            }).catch((error) => {
                dispatch(VARIANT_DISCOUNTS_CRUD_FORM_CANCEL(null));
            });

        //dispatch(VARIANT_TAG_CRUD_FORM_BATCH_EDIT());
    };
};

export const viewDiscountsByVariantIdEvent = (variant) => {
    return async (dispatch, state) => {

        if (typeof state.variantDiscounts != 'object') {
            state.variantDiscounts = {};
        }

        var discounts = state.variantDiscounts[variant.id];

        if (discounts && discounts.visibility) {
            discounts.visibility = !discounts.visibility;
            dispatch(VARIANT_DISCOUNTS_DISPLAY_BAR(state.variantDiscounts));
            return;
        }

        state.variantDiscounts[variant.id] = {
            visibility: true,
            data: null,
            state: "LOADING"
        };

        dispatch(VARIANT_DISCOUNTS_DISPLAY_BAR(state.variantDiscounts));

        getDiscountsByVariantId(variant.id)
            .then((result) => {
                let discounts = result.content;
                if (Array.isArray(discounts) && discounts.length > 0) {
                    discounts = discounts.map(discount => ({ id: discount.id, name: discount.name }));
                }

                state.variantDiscounts[variant.id] = {
                    visibility: !!discounts,
                    data: { ...variant, discounts: discounts },
                    state: "DONE"
                };
                dispatch(VARIANT_DISCOUNTS_DISPLAY_BAR(state.variantDiscounts));
            }).catch((error) => {
                state.variantDiscounts[variant.id] = {
                    visibility: false,
                    data: {},
                    state: "ERROR",
                    error: true
                };
                dispatch(VARIANT_DISCOUNTS_DISPLAY_BAR(state.variantDiscounts));
            });
    }
};

export const updateDiscountsByVariantIdEvent = (form, id) => {
    return async (dispatch, state) => {
        const [encoded, decoded] = $serializeForm(form.current);
        //console.log('updateDiscountsByVariantIdEvent.result', decoded);
        let payload = { id: decoded.id, discounts: decoded.discountSelected };

        updateDiscountsByVariantId(decoded.id, payload)
            .then((result) => {
                console.log('updateDiscountsByVariantId.successful', result);
                dispatch(VARIANT_DISCOUNTS_CRUD_FORM_CANCEL(null));
            })
            .catch((error) => {
                console.error("updateDiscountsByVariantId.Error:", error);
            });
    };
};

export const applyDiscountsToSelectedVariantsEvent = (list, input) => {

    let [json, decoded] = $serializeForm(input.current.getForm());
    let discountSelected = decoded.discountSelected;
    let variants = Object.keys(list.current.getChecked());
    let payload = { variants: variants, discounts: discountSelected };

    console.error("applyDiscountsToAllSelectedVariantsEvent:", payload);

    putDiscountsToVariants(payload)
        .then((result) => {
            console.log('applyDiscountsToAllSelectedVariantsEvent', result.content);
        })
        .catch(error => {
            console.error('applyDiscountsToAllSelectedVariantsEvent', error);
        });

}

export const deleteDiscountsFromSelectedVariantsEvent = (list, input) => {

    let [json, decoded] = $serializeForm(input.current.getForm());
    let discountSelected = decoded.discountSelected;
    let variants = Object.keys(list.current.getChecked());
    let payload = { variants: variants, discounts: discountSelected };

    deleteDiscountsFromVariants(payload)
        .then((result) => {
            console.log('applyDiscountsToAllSelectedVariantsEvent', result.content);
        })
        .catch(error => {
            console.error('applyDiscountsToAllSelectedVariantsEvent', error);
        });

}

export const deleteAllDiscountsFromSelectedVariantsEvent = (list) => {

    let variants = Object.keys(list.current.getChecked());
    let payload = { ids: variants };

    deleteAllDiscountsFromVariants(payload)
        .then((result) => {
            console.log('deleteAllDiscountsFromSelectedVariantsEvent', result.content);
        })
        .catch(error => {
            console.error('deleteAllDiscountsFromSelectedVariantsEvent', error);
        });

}

export const deleteAllDiscountsByVariantId = (id) => {

    if (id > 0) {
        let payload = { ids: [id] };

        deleteAllDiscountsFromVariants(payload)
            .then((result) => {
                console.log('deleteAllDiscountsFromSelectedVariantsEvent', result.content);
            })
            .catch(error => {
                console.error('deleteAllDiscountsFromSelectedVariantsEvent', error);
            });
    }
}